import type { GetterTree } from 'vuex'
import type { RootState } from 'store'
import type { ApplicationState } from './types'

export const getters: GetterTree<ApplicationState, RootState> = {
  application: (state: ApplicationState) => state.application,
  applications: (state: ApplicationState) => state.applications,
  total: (state: ApplicationState) => state.applications && state.applications.length,
  logsInWeek: (state: ApplicationState) => state.logsInWeek,
  totalLogsInWeek: (state: ApplicationState) => state.totalLogsInWeek,
  errorLogsInWeek: (state: ApplicationState) => state.errorLogsInWeek,
  successLogsInWeek: (state: ApplicationState) => state.successLogsInWeek,
  selectedApplicationIds: (state: ApplicationState) => state.selectedApplicationIds,
}
